import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as CryptoJS from 'crypto-js';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { AuthService } from '../.././services/auth.service';
import { GradeService } from '../.././services/grade.service';
import { ProfileMediaService } from '../.././services/profile-media.service';
import { RoleService } from '../.././services/role.service';
import { SchoolService } from '../.././services/school.service';
import { StorageService } from '../.././services/storage.service';
import { StudentService } from '../.././services/student.service';
import { AnalyticsService } from '../../@core/utils/analytics.service';
import {
  validateEmail,
  validateMobileNumber,
  validateName,
  validatePassword,
} from '../../@theme/directives/validators';
import { DATABASE_UPLOADED_STATICS_URLS } from '../../config/database_uploaded_statics_urls';
import { ROLEVALUES } from '../../enum/roles.enum';
import { Classroom } from '../../interface/calendar';
import { Grades } from '../../interface/grades';
import { School } from '../../interface/school';
import { Role, User } from '../../interface/user';
import { AcademicYearService } from '../../services/academic-year.service';
import { ClassroomService } from '../../services/classroom.service';
import { HttpService } from '../../services/http.service';
import { ToasterService } from '../../services/toaster.service';
import { UtilService } from '../../services/util.service';
import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';
// import { MatDialogComponent } from '../mat-dialog/mat-dialog.component';

@Component({
  selector: 'ngx-add-user-signup',
  templateUrl: './add-user-signup.component.html',
  styleUrls: ['./add-user-signup.component.scss'],
})
export class AddUserSignupComponent implements OnInit, AfterContentChecked, OnDestroy {
  loading = false;
  addUserForm: FormGroup;
  public assignClassroomsForm: FormGroup;
  roles: Role[];
  grades: Grades[] | any;
  schools: any;
  user;
  currentProfile;
  fileMe;
  isShool = false;
  isValidUser = this.route.snapshot.paramMap.get('user') ? true : false;
  isShowPassword = false;
  isShowConfirmPassword = false;
  minDate = new Date();
  userToUpdate: User | any;
  maxDateTbExpiration: any;
  maxDateBirthdate: any;
  minDateOfHire: any;
  studentValues = [];
  validatedStudentCodes = [];
  validateStudents = [];
  public modalRef;
  @ViewChild('myModal') myModal;
  public userClassrooms: any;
  @ViewChild('dialogArchive') dialogArchive: TemplateRef<any>;
  currentSchools: [] = [];
  currentSelectedSchool;
  schoolSearchSubscription: Subscription;
  filteredSchools: School[] = [];
  isStudentValidated = false;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private roleService: RoleService,
    private gradeService: GradeService,
    private schoolService: SchoolService,
    public storageService: StorageService,
    private profileService: ProfileMediaService,
    private authService: AuthService,
    public alayticsService: AnalyticsService,
    private studentService: StudentService,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private httpService: HttpService,
    public modalService: NgbModal,
    private classroomService: ClassroomService,
    private spinner: NgxSpinnerService,
    public matDialog: MatDialog,
    private utilService: UtilService,
    private academicYearService: AcademicYearService,
  ) {}

  async ngOnInit() {
    try {
      this.spinner.show();

      this.getFormControls();
      // Disable academic year and school header
      this.academicYearService.disableAcademicHeader.next(true);
      this.academicYearService.disableSchoolHeader.next(true);

      this.getStudentCode();
      this.loading = true;
      this.maxDateBirthdate = new Date(this.minDate.getFullYear() - 4, this.minDate.getMonth(), this.minDate.getDate());

      this.user = await this.storageService.getItem('user');

      this.roles = (await this.roleService.getAllRoles()) as Role[];
      this.roles.splice(
        this.roles.findIndex((x) => x.id === 19),
        1,
      );
      this.grades = await this.gradeService.getAllGrades();
      this.schools = await this.getSchools();

      this.currentSchools = this.schools;
      // remove the teacher only schools and teacher_only user role from admin portal
      if (
        (this.user && this.user.user.role_id === ROLEVALUES.SUPER_ADMIN) ||
        this.storageService.checkUserRole(this.user.user.role_id, 'admin')
      ) {
        this.schools = this.schools.filter((x) => !x.name.includes('teachers_only_school_'));
        this.roles.splice(
          this.roles.findIndex((x) => x.id === ROLEVALUES.TEACHER_ONLY),
          1,
        );
      }
      if (this.user && this.user.user.role_id !== 19) this.addSchoolCode();

      const userId = Number(this.route.snapshot.paramMap.get('id'));

      if (userId) {
        this.userToUpdate = await this.authService.userById(userId);

        if (this.userToUpdate?.id) {
          this.patchFormValues();
          // const selectedSchools = this.adminSchools();

          // if (selectedSchools.length > 0)
          //   this.schools = this.schools.filter(
          //     (school) =>
          //       selectedSchools.includes(school?.id) ||
          //       school?.id === this.user?.user?.school_id,
          //   );
        }
      } else {
        this.router && !this.router.url.includes('sign-up')
          ? this.addUserPassword()
          : this.addUserForm.patchValue({
              role: 13,
              grade: 1,
            });
      }
      this.filteredSchools = [...this.schools];

      this.spinner.show();

      this.loading = false;
    } catch (error) {
      // console.log(error);
      this.spinner.show();

      this.loading = false;
    }
  }

  async getSchools() {
    try {
      const selectedSchools = this.adminSchools();
      if (selectedSchools?.length > 0) {
        return await this.schoolService.getMultipleSchoolsByIds({
          school_ids: selectedSchools,
        });
      } else {
        return await this.schoolService.getAllSchools();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  adminSchools() {
    try {
      const schoolsIds = this?.user?.user?.profileData?.selectedSchools;
      schoolsIds.unshift(this?.user?.user?.school_id);
      return schoolsIds;
    } catch (error) {
      // console.log(error)
    }
  }

  async patchFormValues() {
    try {
      this.isValidUser = true;

      this.currentProfile = this.userToUpdate?.user_profile_media_id > 0 ? this.userToUpdate?.user_profile_media : null;
      this.addUserForm.patchValue({
        firstName: this.userToUpdate?.firstName,
        lastName: this.userToUpdate?.lastName,
        role: this.userToUpdate?.role_id,
        email: this.userToUpdate?.email,
        contact: this.userToUpdate?.contact ? this.userToUpdate?.contact : null,
        grade: this.userToUpdate?.profileData?.grades ? this.userToUpdate?.profileData?.grades : 1,
        dob: this.userToUpdate?.birthdate ? new Date(this.userToUpdate?.birthdate) : null,
        address: this.userToUpdate?.address,
        school: this.userToUpdate?.school_id,
        schoolCode: this.userToUpdate?.school?.code,
        id_code: this.userToUpdate?.school_indentity_number,
        dateOfCriminalBackground: this.userToUpdate?.profileData?.dateOfCriminalBackground
          ? new Date(this.userToUpdate?.profileData?.dateOfCriminalBackground)
          : null,
        dateOfHire: this.userToUpdate?.profileData?.dateOfHire
          ? new Date(this.userToUpdate?.profileData?.dateOfHire)
          : null,
        credentialDocumentNumber: this.userToUpdate?.profileData?.credentialDocumentNumber,

        credentialTypeEmployment: this.userToUpdate?.profileData?.credentialTypeEmployment,
        credentialExpirationDate: this.userToUpdate?.profileData?.credentialExpirationDate
          ? new Date(this.userToUpdate?.profileData?.credentialExpirationDate)
          : null,
        tbClearanceDate: this.userToUpdate?.profileData?.tbClearanceDate
          ? new Date(this.userToUpdate?.profileData?.tbClearanceDate)
          : null,
        tbExpirationDate: this.userToUpdate?.profileData?.tbExpirationDate
          ? new Date(this.userToUpdate?.profileData?.tbExpirationDate)
          : null,
        parentEmail:
          this.userToUpdate?.role_id === 18 && this.userToUpdate?.profileData?.parentEmail
            ? this.userToUpdate?.profileData?.parentEmail
            : '',
        studentCode:
          this.userToUpdate?.role_id === 18 && this.userToUpdate?.profileData?.studentCode
            ? this.userToUpdate?.profileData?.studentCode
            : '',
        teacherViewAccess: this.userToUpdate?.profileData?.isTeacherView === true ? 'true' : 'false',
        userManangementPrivileges: this.userToUpdate?.profileData?.isManageUsers ? 'true' : 'false',
        multipleSchoolPrivilages: this.userToUpdate?.profileData?.isViewMultipleSchools ? 'true' : 'false',
        selectedSchools: this.userToUpdate?.profileData?.selectedSchools
          ? this.userToUpdate?.profileData?.selectedSchools
          : [],
        password: 'MyPassword123',
        confirmPassword: 'MyPassword123',
      });

      this.studentValues = this.userToUpdate.profileData?.students;

      this.userToUpdate.profileData?.students?.length > 0 ? await this.patchStudents() : null;
    } catch (error) {}
  }

  addUserPassword() {
    try {
      this.isValidUser = true;
    } catch (error) {
      // console.log(error);
    }
  }

  addSchoolCode(event?) {
    try {
      if (event) {
        const school = this.schools.filter((x) => x.id === event);
        this.multipleSchools(school[0]);
        this.addUserForm.patchValue({
          schoolCode: school[0].code,
        });
      } else {
        this.addUserForm.patchValue({
          school: this.user.user.school_id,
          schoolCode: this.user.user.school.code,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  getFormControls(): void {
    this.addUserForm = this.fb.group({
      firstName: ['', [Validators.required, validateName]],
      lastName: ['', [Validators.required, validateName]],
      role: ['', Validators.required],
      email: ['', [Validators.required, validateEmail]],
      contact: ['', [validateMobileNumber]],
      grade: ['', Validators.required],
      dob: [''],
      address: [''],
      school: ['', Validators.required],
      schoolCode: ['', Validators.required],
      password: ['', Validators.required, validatePassword],
      students: this.fb.array([this.createStudentGroup()]),
      confirmPassword: ['', Validators.required],
      dateOfCriminalBackground: [''],
      dateOfHire: [''],
      credentialDocumentNumber: [''],
      credentialTypeEmployment: [''],
      credentialExpirationDate: [''],
      tbClearanceDate: [''],
      tbExpirationDate: [''],
      teacherViewAccess: [''],
      multipleSchoolPrivilages: [''],
      userManangementPrivileges: [''],
      selectedSchools: [[]],
      parentEmail: ['', validateEmail],
      studentCode: [''],
      id_code: ['', Validators.required],
      schoolSearch: [''],
    });

    this.assignClassroomsForm = this.fb.group({
      users: [[], Validators.required],
      classrooms: [[], Validators.required],
    });

    // Subscribe to search input changes for filtering schools
    this.schoolSearchSubscription = this.addUserForm.get('schoolSearch')?.valueChanges.subscribe((term) => {
      this.filterSchools(term);
    });
  }

  getSchoolByCode(event) {
    try {
      const school = this.schools.filter((x) => x.code === event.target.value);

      school && school.length > 0 ? this.addSchoolValue(true, school) : this.addSchoolValue(false);
    } catch (error) {
      // console.log(error);
    }
  }

  addSchoolValue(isSchool = false, school?) {
    try {
      if (isSchool) {
        this.isShool = true;

        this.addUserForm.patchValue({
          school: school[0].id,
        });
      } else {
        this.isShool = false;
        this.addUserForm.controls['school'].reset();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  getUserRole(roleId: number): void {
    try {
      if (roleId !== 18) {
        this.addUserForm.patchValue({
          grade: this.grades[0].id,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async onFileChange(event: any) {
    try {
      this.loading = true;
      this.fileMe = event.target.files[0];
      await this.setUserProfile();
    } catch (error) {
      // console.log(error);
      this.loading = false;
    }
  }

  async setUserProfile() {
    try {
      const data = new FormData();
      const fileName = this.fileMe.name.toLowerCase().replace(/ /g, '-');
      data.append('image', this.fileMe, fileName);
      await this.addProfile(data);
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async addProfile(data) {
    try {
      this.currentProfile = await this.profileService.uploadProfile(data);
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  async addUser(isValidate = false) {
    try {
      this.loading = true;

      if (!this.router.url.includes('sign-up') ? this.addUserForm.valid : true) {
        this.alayticsService.trackEvent('Add User In Database', 'Add User Signup');
        const body = {
          firstName: this.addUserForm.value.firstName,
          lastName: this.addUserForm.value.lastName,
          email: this.addUserForm.value.email,
          password: this.addUserForm.value.password,
          role_id: this.addUserForm.value.role,
          school_id: this.addUserForm.value.school,
          isNewUser: this.router.url.includes('/sign-up')
            ? this.addUserForm.value.role === 18 || this.addUserForm.value.role === 20
              ? false
              : true
            : true,
          profileData: await this.getProfileData(),
          teachingInfo: this.userToUpdate?.teachingInfo ? this.userToUpdate?.teachingInfo : '',
          user_profile_media_id: this.currentProfile?.id,
          contact: this.addUserForm.value.contact ? Number(this.addUserForm.value.contact) : '',
          address: this.addUserForm.value.address,
          birthdate: new Date(this.addUserForm.value.dob).getTime(),
          school_indentity_number: this.addUserForm.value.id_code,
        };
        if (this.router.url.includes('sign-up')) {
          await this.checkIfSchoolCodeUsed(body.school_id, body, isValidate);
        } else {
          const isValidUser =
            this.addUserForm.value.role === 18 && this.addUserForm.value.parentEmail
              ? await this.checkIfParentExistWithEmail()
              : true;

          if (this.userToUpdate && this.userToUpdate.id) {
            body['id'] = this.userToUpdate?.id;
            body['isNewUser'] = this.userToUpdate?.isNewUser;
            isValidUser
              ? await this.addUserToDatabase(body, true)
              : this.toasterService.showToast('No Parent Found for Current School with this email', 'danger');
          } else {
            isValidUser
              ? await this.addUserToDatabase(body)
              : this.toasterService.showToast('No Parent Found for Current School with this email', 'danger');
          }
        }
      } else {
        Object.keys(this.addUserForm.controls).forEach((field) => {
          const control = this.addUserForm.get(field);

          control.markAsTouched({
            onlySelf: true,
          });
        });
      }

      this.loading = false;
    } catch (error) {
      // console.log(error);
      this.loading = false;
    }
  }

  async checkIfParentExistWithEmail() {
    try {
      const body = {
        email: this.addUserForm.value.parentEmail,
        school_id: this.addUserForm.value.school,
      };

      const user: any = await this.authService.getParentsByEmail(body);

      return user && user.length > 0 ? true : false;
    } catch (error) {
      // console.log(error)
    }
  }

  async getStudentCode(isGenerate = false) {
    try {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;

      for (let i = 0; i < 6; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      const checkStudent: any = await this.authService.getStudentByStudentCode({
        code: result,
      });

      if (checkStudent && checkStudent.length > 0) {
        isGenerate ? this.toasterService.showToast('Student Code Already Used.', 'danger') : null;

        return null;
      } else {
        if (isGenerate) {
          this.addUserForm.patchValue({
            studentCode: result,
          });
        } else {
          return result;
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async getProfileData() {
    try {
      if (this.addUserForm.value.role === 18) {
        return {
          grades: this.addUserForm.value.grade,
          parentEmail: this.addUserForm.value.parentEmail ? this.addUserForm.value.parentEmail : null,
          studentCode: this.userToUpdate ? this.addUserForm.value.studentCode : await this.getStudentCode(),
        };
      } else if (this.storageService.checkUserRole(this.addUserForm.value.role, 'teacher')) {
        return {
          // dateOfHire: this.addUserForm.value.dateOfHire ? this.formatDate(this.addUserForm.value.dateOfHire) : null,
          // tbClearanceDate: this.addUserForm.value.tbClearanceDate
          //   ? this.formatDate(this.addUserForm.value.tbClearanceDate)
          //   : null,
          // tbExpirationDate: this.addUserForm.value.tbExpirationDate
          //   ? this.formatDate(this.addUserForm.value.tbExpirationDate)
          //   : null,
          // credentialDocumentNumber: this.addUserForm.value.credentialDocumentNumber
          //   ? this.addUserForm.value.credentialDocumentNumber
          //   : null,
          // credentialExpirationDate: this.addUserForm.value.credentialExpirationDate
          //   ? this.formatDate(this.addUserForm.value.credentialExpirationDate)
          //   : null,
          // credentialTypeEmployment: this.addUserForm.value.credentialTypeEmployment
          //   ? this.addUserForm.value.credentialTypeEmployment
          //   : null,
          // dateOfCriminalBackground: this.addUserForm.value.dateOfCriminalBackground
          //   ? this.formatDate(this.addUserForm.value.dateOfCriminalBackground)
          //   : null,
          dateOfHire: this.addUserForm.value.dateOfHire ? new Date(this.addUserForm.value.dateOfHire).getTime() : null,
          tbClearanceDate: this.addUserForm.value.tbClearanceDate
            ? new Date(this.addUserForm.value.tbClearanceDate).getTime()
            : null,
          tbExpirationDate: this.addUserForm.value.tbExpirationDate
            ? new Date(this.addUserForm.value.tbExpirationDate).getTime()
            : null,
          credentialDocumentNumber: this.addUserForm.value.credentialDocumentNumber
            ? this.addUserForm.value.credentialDocumentNumber
            : null,
          credentialExpirationDate: this.addUserForm.value.credentialExpirationDate
            ? new Date(this.addUserForm.value.credentialExpirationDate).getTime()
            : null,
          credentialTypeEmployment: this.addUserForm.value.credentialTypeEmployment
            ? this.addUserForm.value.credentialTypeEmployment
            : null,
          dateOfCriminalBackground: this.addUserForm.value.dateOfCriminalBackground
            ? new Date(this.addUserForm.value.dateOfCriminalBackground).getTime()
            : null,
        };
      } else if (
        (this.addUserForm.value.role >= 11 && this.addUserForm.value.role <= 17) ||
        this.addUserForm.value.role === 4 ||
        this.addUserForm.value.role === 21
      ) {
        return {
          isManageUsers:
            this.addUserForm.value.userManangementPrivileges &&
            this.addUserForm.value.userManangementPrivileges === 'true'
              ? true
              : false,
          isTeacherView:
            this.addUserForm.value.teacherViewAccess && this.addUserForm.value.teacherViewAccess === 'true'
              ? true
              : false,
          isViewMultipleSchools:
            this.addUserForm.value.multipleSchoolPrivilages &&
            this.addUserForm.value.multipleSchoolPrivilages === 'true'
              ? true
              : false,
          selectedSchools:
            this.addUserForm.value.selectedSchools && this.addUserForm.value.selectedSchools
              ? this.getSelectedSchools()
              : [],
        };
      } else if (this.addUserForm.value.role === 20) {
        return {
          students: this.studentValues ? this.studentValues : null,
        };
      } else {
        return;
      }
    } catch (error) {
      // console.log(error);
    }
  }

  getSelectedSchools() {
    try {
      return this.user?.user?.school_id && this.addUserForm.value.selectedSchools.includes(this.user?.user?.school_id)
        ? this.addUserForm.value.selectedSchools.splice(
            this.addUserForm.value.selectedSchools.findIndex((x) => x === this.user?.user?.school_id),
            1,
          )
        : this.addUserForm.value.selectedSchools;
    } catch (error) {
      // console.log(error);
    }
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  async checkIfSchoolCodeUsed(schoolId: number, userBody, isValidate = false) {
    try {
      const school = this.schools.filter((x) => x.id === schoolId);
      const user: any = await this.checkUserWithEmailAndUpdateToDatabase(school[0], userBody, isValidate);

      if (isValidate) {
        if (user?.length > 0) {
          if (school && school.length > 0) {
            if (!user[0]?.isNewUser) {
              this.toasterService.showToast('User Already Signed Up.', 'danger');
            } else {
              if (isValidate) {
                if (user && user.length > 0) {
                  this.patchUserValues(user[0]);
                } else {
                  this.isValidUser = false;
                  this.toasterService.showToast('No User Found for Current School with this email', 'danger');
                }
              } else {
                await this.checkUserWithEmailAndUpdateToDatabase(school[0], userBody, isValidate);
              }
            }
          } else {
            this.toasterService.showToast('No School Found for this code', 'danger');
          }
        } else {
          this.toasterService.showToast('No User Found For Current Email!', 'danger');
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async patchUserValues(user, isRegister = false) {
    try {
      this.isValidUser = true;
      this.addUserForm.patchValue({
        firstName: user.firstName,
        lastName: user.lastName,
        role: user.role_id,
        contact: user?.contact ? user?.contact : '',
        dob: user?.birthdate ? new Date(user?.birthdate) : null,
        address: user.address,
        teacherViewAccess: user?.profileData?.isTeacherView === true ? 'true' : 'false',
        userManangementPrivileges: user?.profileData?.isManageUsers === true ? 'true' : 'false',
        id_code: user?.school_indentity_number,
        multipleSchoolPrivilages: user?.profileData?.isViewMultipleSchools === true ? 'true' : 'false',
        selectedSchools: user?.profileData?.selectedSchools ? user?.profileData?.selectedSchools : [],
      });

      if (isRegister) {
        const school = this.schools.filter((x) => x.code === user.school.code);

        school && school.length > 0 ? this.addSchoolValue(true, school) : this.addSchoolValue(false);

        this.addUserForm.patchValue({
          email: user?.email,
          schoolCode: user?.school?.code,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async checkUserWithEmailAndUpdateToDatabase(school, body, isValidate = false) {
    try {
      const userBody = {
        email: body.email,
        school_id: body.school_id,
        role_id: body.role_id,
      };

      const user: any = await this.authService.getUserBySchoolIdRoleIdAndEmail(userBody);

      if (isValidate) {
        return user;
      } else {
        if (user && user.length > 0) {
          await this.updateSchool(school);
          if (this.router.url.includes('sign-up')) body['profileData'] = user[0].profileData;
          await this.updateUser(user[0].id, body);
        } else {
          this.toasterService.showToast('No User Found for Current School with this email', 'danger');
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async updateUser(id, body) {
    try {
      const response = await this.authService.updateUserWithPassword(id, body);

      if (response && response.id) {
        const userLoginBody = {
          email: this.addUserForm.value.email,
          password: this.addUserForm.value.password,
        };

        const user: any = await this.authService.login(userLoginBody);
        if (user?.user) {
          this.addUserForm.reset();
          this.currentProfile = null;
          this.storageService.setItem('user', user);
          const decryptedUser: any = this.httpService.decodeLoginToken(user?.user);

          this.redirectUser(decryptedUser?.role_id);
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  redirectUser(roleId: number) {
    try {
      switch (roleId) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
          this.router.navigateByUrl('/calendar');
          break;

        case 9:
          this.router.navigateByUrl('/administration/teacher-profile');
          break;
        case 10:
        case 11:
          this.router.navigateByUrl('/calendar');
          break;
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
          this.router.navigateByUrl('/administration/school-instructional-peroids');
          break;
        case 18:
        case 19:
        case 20:
          this.router.navigateByUrl('/calendar');
          break;
      }
    } catch (error) {
      // console.log(error)
    }
  }

  async updateSchool(school) {
    try {
      const body = {
        school_id: school.id,
        name: school.name,
        city: school.city,
        state: school.state,
        country: school.country,
        code: school.code,
        phone: school.phone,
        school_periods: school.school_periods,
        start_time: school.start_time,
        end_time: school.end_time,
        start_date: school.start_date,
        end_date: school.end_date,
        isNew: false,
        limitation_user_number: school?.limitation_user_number,
        school_logo_id: school?.school_logo_id,
        subscription: school?.subscription ? school?.subscription : false,
      };

      await this.schoolService.updateSchool(school.id, body);
    } catch (error) {
      // console.log(error);
    }
  }

  async addUserToDatabase(body, isUpdate = false) {
    try {
      let response;
      const isUserExist = await this.authService.userByIndentityCode({
        school_identity_code: body?.school_indentity_number,
        school_id: body?.school_id,
        user_id: body?.id,
      });

      if (isUserExist?.length > 0) {
        this.toasterService.showToast('Duplicate Identity Number Found', 'danger');
      } else {
        if (isUpdate) {
          response = await this.authService.updateUser(body.id, body);
        } else {
          // const isUserCountValid = await this.getIfUserCountOfSchoolIsValid(body?.school_id); // Validate user count before proceeding; show error and stop if limit is exceeded.

          // if (isUserCountValid) {
          response = await this.authService.addUser(body);
          // } else {
          //   this.toasterService.showToast('User Limitation Exceeded', 'danger');
          // }
        }

        if (response && response.id) {
          !isUpdate ? (response.role_id === 18 ? await this.addStudent(response) : null) : null;

          if (!isUpdate) {
            this.sendUserEmail(response.id);
          }
          this.router.navigateByUrl('/manage-users');
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async sendUserEmail(userId: number) {
    try {
      const emailBody = {
        type: 'new_admin_user',
        key: 'respondedu1234567890123456789012',
        user_id: userId,
      };

      const encryptedData = CryptoJS.AES.encrypt(
        JSON.stringify(emailBody),
        'paramsRespondEDU1234567890123456789012',
      ).toString();

      const mainUrl = this.utilService.getMainUrl();
      const url = `https://${mainUrl}/auth/reset-password?data=${encryptedData}`;

      const body = {
        to: this.addUserForm.value.email,
        cc: '',
        bcc: '',
        subject: 'RespondEDU Account Login Details',
        html: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
      <html xmlns="http://www.w3.org/1999/xhtml">
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
          <title></title>
          <style type="text/css">
          .info-text {
            font-family: Quicksand;
            font-size: 14px;
            font-weight: 500;
            line-height: 18px;
            color: #000000;
          }
            </style>
        </head>
        <body>
        <div style="display:flex"><img style="width: 182px; margin-left: -27px;" src='${DATABASE_UPLOADED_STATICS_URLS.logo_img_url}' loading='lazy' /></div>
        <p class="info-text">Dear ${this.addUserForm.value.firstName} ${this.addUserForm.value.lastName},</p>
        <p class="info-text" style="margin-top: -7px"> We hope this email finds you well. As per your request, we are pleased to provide you with your username and password details for accessing
        Respond EDU Dashboard
        </p>
       

        <p class="info-text" style="background-color: #F2F4F7; padding: 15px; color: #000000;">
         Please follow the below link for resetting the password, and then you can login to the portal using the provided credentials.
        </p>

        <a style="cursor:pointer" href="${url}" class="info-text">Reset Password</a>
        <p style="font-size:11px" class="info-text">(Link will be expired in 24 hours)</p>
        <p class="info-text">
        Remember this link will only be valid for 24 hours. If you do not reset your password within 24 hours, you will need to request a new link.
        </p>

        <p style="margin-top: 2rem" class="info-text">If you encounter any issues logging in or have any questions, feel free to contact our support team at <a href="mailto:support@respondedu.com"> support@respondedu.com </a></p>
        <p style="margin-top: 2rem;" class="info-text">Thank you for choosing <b>Respond EDU.</b> We look forward to serving you.</p>
        <p class="info-text">Best regards,</p>
        <p style="margin:0" class="info-text"><a href="https://www.respondedu.com/">Respond EDU<a/> Team.</p>
        </body>
      </html>`,
      };
      const response = await this.authService.sendUserEmail(body);
      if (response && response['code'] === 200) {
        this.addTokenToDatabase(encryptedData, userId);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async addTokenToDatabase(encryptedData, userId) {
    try {
      await this.authService.addEmailVerification({
        url: encryptedData,
        user_id: userId,
        is_valid: true,
      });
    } catch (error) {
      // console.log(error)
    }
  }

  /**
   * @description
   * Determines if a new user can be added to a school by checking whether the number of users
   * with similar roles has reached the predefined limit.
   *
   * - Determines role group based on the selected role from the form.
   * - Fetches users with the relevant roles for the given school ID.
   * - Compares current user count with the allowed limit set for that role group in the school's config.
   *
   * @param {number} id - The ID of the school to validate against.
   * @returns {Promise<boolean | undefined>}
   * - `true` if user can be added within the limit,
   * - `false` if the role-based user limit is reached or exceeded,
   * - `undefined` if an error occurs.
   */
  // async getIfUserCountOfSchoolIsValid(id: number) {
  //   try {
  //     const roles: any = Object.values(ROLEVALUES);
  //     const users: any = await this.authService.userByRoleId({
  //       school_id: id,
  //       role_id: this.storageService.checkUserRole(this.addUserForm.value.role, 'teacher')
  //         ? [ROLEVALUES.TEACHER_ASSISTANT, ROLEVALUES.RSP_TEACHER, ROLEVALUES.TEACHER, ROLEVALUES.SPED_SUPPORT_STAFF]
  //         : this.addUserForm.value.role === ROLEVALUES.STUDENT
  //           ? [this.addUserForm.value.role]
  //           : roles.filter(
  //               (num) =>
  //                 num !== ROLEVALUES.TEACHER_ASSISTANT &&
  //                 num !== ROLEVALUES.STUDENT &&
  //                 num !== ROLEVALUES.RSP_TEACHER &&
  //                 num !== ROLEVALUES.SPED_SUPPORT_STAFF &&
  //                 num !== ROLEVALUES.TEACHER,
  //             ),
  //     });

  //     if (users?.length === 0) {
  //       return true;
  //     } else {
  //       const userRole = this.addUserForm.value.role;
  //       const limitVariable =
  //         userRole === 18
  //           ? 'studentLimit'
  //           : this.storageService.checkUserRole(userRole, 'teacher')
  //             ? 'teacherLimit'
  //             : 'otherUserLimit';

  //       return users[0]?.school?.limitation_user_number[limitVariable] <= users?.length ? false : true;
  //     }
  //   } catch (error) {
  //     // console.log(error)
  //   }
  // }

  async addStudent(user) {
    try {
      const studentBody = {
        attendence_status: 'regular',
        grade_avg: 0,
        homework_progress: 0,
        quiz_progress: 0,
        extra_help: 0,
        user_id: user.id,
        grades_id: this.addUserForm.value.grade,
        classroom_id: [],
      };

      await this.studentService.addStudent(studentBody);
    } catch (error) {
      // console.log(error);
    }
  }

  onTBClearanceDateChange(event: MatDatepickerInputEvent<Date>) {
    const newDate = new Date(event.value);
    newDate.setFullYear(event.value.getFullYear() + 4);
    this.maxDateTbExpiration = newDate.toISOString();

    this.addUserForm.patchValue({
      tbExpirationDate: this.maxDateTbExpiration,
    });
  }

  onCriminalBackgroundDateChange(event: MatDatepickerInputEvent<Date>) {
    const newDate = new Date(event.value);
    newDate.setDate(newDate.getDate() + 1);
    this.minDateOfHire = newDate.toISOString();
  }
  get studentsDetails() {
    return this.addUserForm.get('students') as FormArray;
  }

  async addStudentCode(userCode: string) {
    try {
      const student = this.fb.group({
        userCode: userCode ? userCode : '',
      });

      this.studentsDetails.push(student);

      // Set validation state based on whether userCode is provided or not (assuming that if userCode is provided, it's already validated)
      this.isStudentValidated = !!userCode;

      // Recalculate button state
      this.updateButtonState();
    } catch (error) {
      // handle error if needed
    }
  }
  removeUser(index: number) {
    try {
      this.studentValues[index] ? this.studentValues.splice(index, 1) : null;
      this.validatedStudentCodes.splice(index, 1);
      this.validateStudents.splice(index, 1);
      this.studentsDetails.removeAt(index);
      // Recalculate button state after removal
      this.updateButtonState();
    } catch (error) {}
  }
  /**
   * @description
   * This method updates the state of the "Add Student" and "Validate Student" buttons based on the current entries in the studentsDetails FormArray and their validation status.
   */
  private updateButtonState() {
    try {
      const totalEntries = this.studentsDetails.length;

      if (totalEntries === 0) {
        // No entries, enable Add Student and disable Validate Student
        this.isStudentValidated = true;
        return;
      }

      // Check if the last remaining entry is validated
      const lastIndex = totalEntries - 1;
      const lastCode = this.studentsDetails.value[lastIndex]?.userCode?.trim();

      const isLastValidated = this.validatedStudentCodes.some((code) => code === lastCode);

      if (isLastValidated) {
        // Last entry is validated, enable Add Student and disable Validate Student
        this.isStudentValidated = true;
      } else {
        // Last entry is not validated, disable Add Student and enable Validate Student
        this.isStudentValidated = false;
      }
    } catch (error) {
      console.log('AddUserSignupComponent ~ updateButtonState ~ error:', error);
    }
  }

  async validateStudent() {
    try {
      const lastIndex = this.studentsDetails.length - 1;
      const lastStudent = this.studentsDetails.value[lastIndex];

      if (lastStudent.userCode !== '') {
        const rawCode = lastStudent.userCode;

        const body = {
          code: this.utilService.cleanWhitespace(rawCode),
        };

        const student: any = await this.authService.getStudentByStudentCode(body);

        if (student && student.length > 0) {
          const isExist = this.studentValues.some((values) => values === student[0].id);

          if (isExist) {
            this.toasterService.showToast('Student Already Exists', 'danger');
            this.isStudentValidated = false; // keep validate enabled
          } else {
            this.toasterService.showToast('Student Validated Successfully', 'success');
            this.studentValues.push(student[0].id);
            this.validatedStudentCodes.push(student[0]?.profileData?.studentCode);
            this.validateStudents.push(student[0]);

            this.isStudentValidated = true; // disable validate after success
          }
        } else {
          this.toasterService.showToast('Student not found', 'danger');
          this.isStudentValidated = false; //enable validate if student not found
        }
      } else {
        this.toasterService.showToast('Please Enter Student Code', 'danger');
        this.isStudentValidated = false;
      }
    } catch (error) {
      // console.log(error);
    }
  }

  createStudentGroup(): FormGroup {
    return this.fb.group({
      userCode: '',
    });
  }

  async patchStudents() {
    try {
      this.studentsDetails.clear();

      const studentCodes: any = await this.authService.getUserByStudentCodes({
        student_id: this.userToUpdate?.profileData?.students,
      });

      for (let i = 0; i < studentCodes?.length; i++) {
        await this.addStudentCode(studentCodes[i]?.profileData?.studentCode);
      }

      this.validatedStudentCodes = studentCodes.map((stu) => stu?.profileData?.studentCode);

      this.validateStudents = studentCodes;
    } catch (error) {
      // console.log(error);
    }
  }

  ngAfterContentChecked(): void {
    try {
      this.changeDetector.detectChanges();
    } catch (error) {
      // console.log(error);
    }
  }

  public async openManageClassroomsModal() {
    try {
      this.loading = true;
      this.userClassrooms = await this.getClassroomsByUserId();
      this.modalRef = this.modalService.open(this.myModal, {
        size: 'lg',
        modalDialogClass: 'mymodal',
        centered: true,
        backdrop: 'static',
        animation: true,
        keyboard: false,
        backdropClass: 'modal-backdrop',
        windowClass: 'custom-overlay-container',
      });

      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error)
    }
  }

  public async getClassroomsByUserId() {
    try {
      return await this.classroomService.classroomByUserId({
        user_id: this.userToUpdate.id,
        school_id: this.userToUpdate.school_id,
        isTeacher: false,
      });
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  public async updateClassrooms() {
    try {
      if (this.assignClassroomsForm.invalid) {
        this.toasterService.showToast('Please fill all the mandatory fields', 'danger');
        return;
      }

      this.loading = true;

      this.assignClassroomsForm.value.classrooms.map((x) => {
        x.new_user_ids = this.assignClassroomsForm.value.users;
        return x;
      });

      const response = await this.classroomService.updateMultipleClassrooms({
        classrooms: this.assignClassroomsForm.value.classrooms,
      });

      if (response && response['id']) {
        this.assignClassroomsForm.reset();
        this.toasterService.showToast('Classrooms assigned to the teachers successfully', 'success');
        this.userClassrooms = await this.getClassroomsByUserId();
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error);
    }
  }

  public async revokeClassroom(classroom: Classroom) {
    try {
      this.loading = true;

      classroom['new_user_ids'] = [];

      const response = await this.classroomService.updateClassroom(classroom.id, classroom);

      if (response && response['id']) {
        this.toasterService.showToast('Classroom has been revoked to the original teacher', 'success');
        this.userClassrooms = await this.getClassroomsByUserId();
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error)
    }
  }
  openConfirmationDialog(): void {
    // this.matDialog.open(this.dialogArchive, {
    //   width: '370px',
    //   height: '350px',
    // });
    const dialogRef = this.matDialog.open(MatDialogComponent, {
      width: '400px',
      data: {
        title: `${this.userToUpdate.isDisable ? 'Enable user' : 'Disable User'}`,
        icon: '/assets/icons/featured icon.svg',
        accessCodeLabel: `${this.userToUpdate.isDisable ? 'Enable user' : 'Disable User'}`,
        confirmationMessage: `Are you sure want to ${this.userToUpdate.isDisable ? 'enable' : 'disable'} this user?`,
        description: `${
          this.userToUpdate.isDisable
            ? ' Enabling the user makes them active throughout portal, they can able to login through the portal again!'
            : 'Disabling the user makes them inactive throughout portal, you can manage them in the inactive users side menu!'
        }`,
        cancelButtonText: 'Cancel',
        confirmButtonText: `${this.userToUpdate.isDisable ? 'Enable' : 'Disable'}`,
        cancelTrackEvent: `Cancel ${this.userToUpdate.isDisable ? 'Enable user' : 'Disable User'}`,
        confirmTrackEvent: `${this.userToUpdate.isDisable ? 'Enable user' : 'Disable User'}`,
        trackPage: 'Add User Signup',
      },
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.disableUser();
      }
    });
  }
  async disableUser() {
    try {
      this.matDialog.closeAll();
      this.loading = true;
      this.userToUpdate['isDisable'] = !this.userToUpdate.isDisable;

      const response = await this.authService.updateUser(this.userToUpdate.id, this.userToUpdate);

      if (response && response['id']) {
        this.toasterService.showToast(`User ${!response.isDisable ? 'Enabled' : 'Disabled'} Successfully`, 'success');
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      // console.log(error)
    }
  }
  async multipleSchools(currentSchool?) {
    try {
      this.addUserForm.patchValue({
        selectedSchools: [],
      });
      this.currentSchools = this.schools.filter((school) => currentSchool?.name !== school.name);
    } catch (error) {
      // console.log(error)
    }
  }
  cities = [
    {
      id: 1,
      name: 'Vilnius',
    },
    {
      id: 2,
      name: 'Kaunas',
    },
  ];

  selectedCity = this.cities[0].name;

  onSearch() {
    // console.log('search called' + item.term);
  }

  testSearch(term: string, item) {
    // console.log(item);
    // console.log(term);
    return item.name.startsWith(term);
  }

  /**
   * @description Filters schools by name using a case-insensitive search term.
   * Resets to all schools if the term is empty or on error.
   * @param {string} searchTerm - Text used to filter school names.
   * @returns {void}
   */
  filterSchools(searchTerm: string): void {
    console.log('Filtering schools with term:', searchTerm);

    try {
      const term = searchTerm?.toLowerCase().trim() || '';
      console.log(term);

      if (!this.schools || !Array.isArray(this.schools)) {
        this.filteredSchools = [];
        return;
      }

      if (!term) {
        this.filteredSchools = [...this.schools];
      } else {
        this.filteredSchools = this.schools.filter((school) => school.name?.toLowerCase().includes(term));
      }
    } catch (error) {
      console.error('Error filtering schools:', error);
      this.filteredSchools = [...(this.schools || [])];
    }
  }
  // Reset the filter values
  onDropdownOpen(): void {
    this.addUserForm.patchValue({
      schoolSearch: '',
    });
    this.filteredSchools = this.schools;
  }

  ngOnDestroy(): void {
    this.schoolSearchSubscription?.unsubscribe();
    // Enable academic year and school header
    this.academicYearService.disableAcademicHeader.next(false);
    this.academicYearService.disableSchoolHeader.next(false);
  }
}
